function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 51,
  height: 50,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.0007 17.4964C13.0007 16.6699 13.6707 16 14.4971 16H36.7288C37.5553 16 38.2252 16.6699 38.2252 17.4964C38.2252 18.3228 37.5553 18.9927 36.7288 18.9927H14.4971C13.6707 18.9927 13.0007 18.3228 13.0007 17.4964Z",
  fill: "#F38530"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 25.1927C13 24.3662 13.6699 23.6963 14.4964 23.6963H36.7281C37.5545 23.6963 38.2245 24.3662 38.2245 25.1927C38.2245 26.0191 37.5545 26.689 36.7281 26.689H14.4964C13.6699 26.689 13 26.0191 13 25.1927Z",
  fill: "#F38530"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 32.8882C13 32.0618 13.6699 31.3918 14.4964 31.3918H36.7281C37.5545 31.3918 38.2245 32.0618 38.2245 32.8882C38.2245 33.7146 37.5545 34.3846 36.7281 34.3846H14.4964C13.6699 34.3846 13 33.7146 13 32.8882Z",
  fill: "#F38530"
});

var SvgBurgerMenuOpenMobile = function SvgBurgerMenuOpenMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurgerMenuOpenMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burger-menu-open-mobile.08a3b6c1.svg";
export { ForwardRef as ReactComponent };